import { Card, Col, Form, Row } from "antd";
import React, { useState } from "react";
import FormAction from "../../../../../../components/common/FormAction";

import Questions from "../../../Components/Questions";

function Questionss() {
  const [checked, setChecked] = useState(false);

  const onCancel = () => {
    setChecked(false);
  };
  return (
    <Card
      title="Questions"
      className="Questions"
      extra={
        !checked ? (
          <span className="onclick-text" onClick={() => setChecked(true)}>
            Edit
          </span>
        ) : null
      }
    >
      {checked ? (
        <Row>
          <Col span={24}>
            <Questions />
          </Col>
          <Col span={24}>
            <FormAction cancel={onCancel} />
          </Col>
        </Row>
      ) : (
        <Form layout="vertical">
          <Form.Item label="Have you toured the home in person? If you have not, when is your tour scheduled?">
            <p>--</p>
            <p>--</p>
          </Form.Item>
          <Form.Item label="Have you ever been convicted of a crime?">
            <p>--</p>
            <p>--</p>
          </Form.Item>
          <Form.Item label="Have you ever filed suit against a landlord?">
            <p>--</p>
            <p>--</p>
          </Form.Item>
          <Form.Item label="Have you ever been a defendant in an unlawful detainer (eviction) lawsuit or defaulted (failed to perform) any obligation of a rental agreement or lease?">
            <p>--</p>
            <p>--</p>
          </Form.Item>
          <Form.Item label="Do you have any questions about the property?">
            <p>--</p>
            <p>--</p>
          </Form.Item>
          <Form.Item label="Do you receive housing assistance such as section 8? If so, please your attach voucher on the last page of the application.">
            <p>--</p>
            <p>--</p>
          </Form.Item>
          <Form.Item label="Do you have a maiden name?">
            <p>--</p>
            <p>--</p>
          </Form.Item>
        </Form>
      )}
    </Card>
  );
}

export default Questionss;
